import { createAction, props } from "@ngrx/store";
import { IUserEventGroup } from "src/app/models/user";

export const getUserEventGroup = createAction("[User Event Group] Load", props<{ uid: string }>());
export const getUserEventGroupSuccess = createAction("[User Event Group] Load Success");
export const getUserEventGroupFailed = createAction("[User Event Group] Load Failed", props<{ errorMessage: string }>());
export const upsertUserEventGroups = createAction("[User Event Group] Upsert", props<{ userEventGroups: IUserEventGroup[] }>());
